@if (isVisible()) {
  <div class="full-page-loading-overlay">
    <div class="loading-content">
      @if (message() || messageKey()) {
        <div class="loading-message">
          <p>{{ message() || (messageKey() | translate: locale.language) }}</p>
        </div>
      }
      <div class="loading-spinner">
        <mat-progress-spinner mode="indeterminate" diameter="64" strokeWidth="4"></mat-progress-spinner>
      </div>
      <mat-progress-bar 
        [mode]="progressMode()" 
        [value]="progressValue()"
        class="loading-progress-bar"></mat-progress-bar>
    </div>
  </div>
}

